import axios from 'axios';

function getComplexityTotal(id, images) {
  let count = 0;
  images.map((image) => {
    if (image.complexityId == id) {
      count += 1;
    }
  });

  return count;
}

export default {
  namespaced: true,
  state: {
    complexityKeysInfo: [],
    clientSecret: null,
    orderId: null,
    complexityId: null,
    images: [],
    sampleImages: [],
    couponObj: null,
    isCreatingOrder: false,
    order: {
      serviceId: null,
      uuid: null,
      name: '',
      instruction: '',
      deliveryTimeId: null,
      addOns: {},
      serviceComponents: [],
      price: null,
      coupon: '',
      is_quotation: false,
      is_draft: false,
    },
  },
  getters: {
    complexityKeysInfo(state) {
      return state.complexityKeysInfo;
    },
    serviceComponents(state) {
      return state.order.serviceComponents;
    },
    clientSecret(state) {
      return state.clientSecret;
    },
    orderId(state) {
      return state.orderId;
    },
    uuid(state) {
      return state.order.uuid;
    },
    name(state) {
      return state.order.name;
    },
    instruction(state) {
      return state.order.instruction;
    },
    images(state) {
      return state.images;
    },
    sampleImages(state) {
      return state.sampleImages;
    },
    complexityId(state) {
      return state.complexityId;
    },
    addOns(state) {
      return state.order.addOns;
    },
    deliveryTimeId(state) {
      return state.order.deliveryTimeId;
    },
    websizes(state) {
      return state.order.addOns.websizes || [];
    },
    adjustment(state) {
      return state.order.addOns.adjustment;
    },
    coupon(state) {
      return state.couponObj;
    },
    order(state) {
      return state.order;
    },
    isQuotationRequest(state) {
      return state.order.is_quotation;
    },
    isCreatingOrder(state) {
      return state.isCreatingOrder;
    },
  },
  mutations: {
    SET_ORDER(state, payload) {
      const order = payload.order;
      this.dispatch("order/setOrderId", {
        orderId: order.id,
      });

      state.images = order.images;
      state.order.serviceId = order.service.id;
      state.order.uuid = order.token;
      state.order.name = order.title;
      state.order.instruction = order.instruction;
      for (const [key, value] of Object.entries(order.addons)) {
        let payload;
        if (key === "margin") {
          payload = {
            key: key,
            value: {
              marginProperty: value.details,
              marginTypeId: value.id,
            },
          };
        } else if (key === "retouch") {
          payload = {
            key: key,
            value: value.id,
          };
        } else {
          payload = {
            key: key,
            value: value,
          };
        }
        this.dispatch("order/setAddOns", payload);
      }

      state.order.is_draft = order.status === "draft";
      const service = payload.services.find((item) => {
        return item.id === order.service.id;
      });

      this.dispatch("service/setSelectedSerice", service);
      this.dispatch("order/setDeliveryTime", {
        timeId: order.delivery_time?.id || null,
      });

      let serviceComponents = [];
      order.serviceComponentChoices.map((item) => {
        if (item.service_component.allow_multiple) {
          if (!serviceComponents[item.service_component.slug]) {
            serviceComponents[item.service_component.slug] = [];
          }
          serviceComponents[item.service_component.slug].push(item.id);
        } else {
          serviceComponents[item.service_component.slug] = item.id;
        }

        let choices = Array.isArray(serviceComponents[item.service_component.slug])
          ? serviceComponents[item.service_component.slug]
          : [serviceComponents[item.service_component.slug]];

        this.dispatch("order/setServiceComponent", {
          id: item.service_component.id,
          slug: item.service_component.slug,
          choices: choices,
        });

        if (order.images.length) {
          this.dispatch("order/setComplexity", {
            complexityId: order.images[0].complexity.id,
          });
        }
      });
    },
    RESET_ORDER(state) {
      state.complexityId = null;
      state.order.uuid = null;
      state.order.name = '';
      state.order.instruction = '';
      state.images = [];
      state.order.deliveryTimeId = null;
      state.order.addOns = {};
      state.order.serviceComponents = [];
      state.order.coupon = '';
      state.order.price = null;
      state.couponObj = null;
      state.clientSecret = null;
      state.orderId = null;
      state.complexityKeysInfo = [];
    },
    SET_SELECTED_SERVICEID(state, id) {
      state.order.serviceId = id;
    },
    SET_UUID(state, uuid) {
      state.order.uuid = uuid;
    },
    SET_NAME(state, name) {
      state.order.name = name;
    },
    SET_INSTRUCTION(state, instruction) {
      state.order.instruction = instruction;
    },
    SET_IMAGE(state, image) {
      state.images.push(image);
    },
    SET_SAMPLE_IMAGE(state, image) {
      state.sampleImages.push(image);
    },
    UPDATE_IMAGE(state, payload) {
      state.images.map((image) => {
        if (image.id === payload.id) {
          image.instruction = payload.instruction;
        }
      });
    },
    DELETE_IMAGE(state, payload) {
      let delIndex;
      state.images.map((image, index) => {
        if (image.id === payload.id) {
          delIndex = index;
        }
      });

      state.images.splice(delIndex, 1);
    },
    DELETE_SAMPLE_IMAGE(state, payload) {
      let delIndex;
      state.sampleImages.map((image, index) => {
        if (image.id === payload.id) {
          delIndex = index;
        }
      });

      state.sampleImages.splice(delIndex, 1);
    },
    SET_COMPLEXITY(state, complexityId) {
      state.complexityId = complexityId;

      state.images.map((image) => {
        image.complexityId = complexityId;
      });

      state.complexityKeysInfo.map(keyInfo => {
        keyInfo.total = getComplexityTotal(keyInfo.id, state.images);
      });
    },
    UPDATE_COMPLEXITY(state, payload) {
      state.images.map((image) => {
        if (image.id === payload.imageId) {
          image.complexityId = payload.complexityId;
        }
      });

      state.complexityKeysInfo.map(keyInfo => {
        keyInfo.total = getComplexityTotal(keyInfo.id, state.images);
      });
    },
    UPDATE_BULK_COMPLEXITY(state, payload) {
      state.images.map((image) => {
        image.complexityId = payload.complexityId;
      });

      state.complexityKeysInfo.map(keyInfo => {
        keyInfo.total = getComplexityTotal(keyInfo.id, state.images);
      });
    },
    SET_ADDONS(state, payload) {
      const obj = {[payload.key]:payload.value};
      state.order.addOns = {...state.order.addOns,...obj};
    },
    DELETE_ADDONS(state, key) {
      delete state.order.addOns[key];
    },
    SET_DELIVERY_TIME(state, timeId) {
      state.order.deliveryTimeId = timeId;
    },
    ADD_COUPON(state, payload) {
      state.couponObj = payload;
    },
    ADD_COUPON_CODE(state, coupon) {
      state.order.coupon = coupon;
    },
    SET_PRICE(state, price) {
      state.order.price = price;
    },
    SET_CLIENT_SECRET(state, clientSecret) {
      state.clientSecret = clientSecret;
    },
    SET_ORDER_ID(state, orderId) {
      state.orderId = orderId;
    },
    SET_SERVICE_COMPONENT(state, payload) {
      if (state.order.serviceComponents.length) {
        state.order.serviceComponents = state.order.serviceComponents.filter(component => {
          return  payload.id !== component.id
        });
      }

      state.order.serviceComponents.push(payload);
      state.order.serviceComponents = state.order.serviceComponents
        .sort((item1,item2) => item1.id - item2.id)
    },
    REMOVE_SERVICE_COMPONENT(state, payload) {
      let arrIndex = null;
      if (state.order.serviceComponents.length) {
        state.order.serviceComponents.map((component, index) => {
          if (payload.id == component.id) {
            arrIndex = index;
          }
        });

        if (arrIndex !== null) {
          state.order.serviceComponents.splice(arrIndex, 1);
          return;
        }
      }
    },
    SET_COMPLEXITYKEYSINFO(state, payload) {
      state.complexityKeysInfo.push({
        id: payload.id,
        title: payload.title,
        total: 0,
        price: payload.price,
      });
    },
    UPDATE_COMPLEXITYKEYSINFO(state) {
      state.complexityKeysInfo.map(keyInfo => {
        keyInfo.total = getComplexityTotal(keyInfo.id, state.images);
      });
    },
    SET_QUOTATION_REQUEST(state, payload) {
      state.order.is_quotation = payload;
    },
    SET_DRAFT(state, payload) {
      state.order.is_draft = payload;
    },
    SET_IS_CREATING_ORDER(state, payload) {
      state.isCreatingOrder = !!payload;
    }
  },
  actions: {
    setOrder({ commit, rootGetters }, payload) {
      commit("SET_ORDER", {
        order: payload,
        services: rootGetters["service/services"],
      });
    },
    setName({ commit }, payload) {
      commit('SET_NAME', payload.name);
    },
    setInstruction({ commit }, payload) {
      commit('SET_INSTRUCTION', payload.instruction);
    },
    setUuid({ commit }, payload) {
      commit('SET_UUID', payload.uuid);
    },
    setImage({ commit }, payload) {
      commit('SET_IMAGE', payload.image);
    },
    setSampleImage({ commit }, payload) {
      commit("SET_SAMPLE_IMAGE", payload.image);
    },
    async updateImage({ commit }, payload) {
      return await axios
        .patch('images/' + payload.id, {
          instruction: payload.instruction,
        })
        .then(() => {
          commit('UPDATE_IMAGE', payload);
        });
    },
    async deleteImage({ commit }, payload) {
      const id = payload?.id;
      if (!id || !Number.isInteger(id) || id <= 0) {
        return Promise.reject(new Error('Invalid image ID. Unable to delete the image.'));
      }

      return await axios
        .delete('images/' + id)
        .then(() => {
          commit('DELETE_IMAGE', payload);
      });
    },
    async deleteSampleImage({ commit }, payload) {
      const id = payload?.id;
      if (!id || !Number.isInteger(id) || id <= 0) {
        return Promise.reject(new Error('Invalid image ID. Unable to delete the sample image.'));
      }
      
      return await axios
        .delete('sample/images/' + id)
        .then(() => {
          commit('DELETE_SAMPLE_IMAGE', payload);
      });
    },
    setComplexity({ commit }, payload) {
      commit('SET_COMPLEXITY', payload.complexityId);
    },
    async updateComplexity({ commit }, payload) {
      return await axios
        .patch('images/' + payload.imageId, {
          complexity: payload.complexityId,
        })
        .then(() => {
          commit('UPDATE_COMPLEXITY', payload);
        });
    },
    async updateBulkComplexity({ commit }, payload) {
      return await axios
        .post('image-complexity', {
          token: payload.token,
          complexity: payload.complexityId,
        })
        .then(() => {
          commit('UPDATE_BULK_COMPLEXITY', payload);
        });
    },
    setAddOns({ commit }, payload) {
      commit('SET_ADDONS', payload);
    },
    deleteAddOns({ commit }, payload) {
      commit('DELETE_ADDONS', payload.key);
    },
    setDeliveryType({ commit }, payload) {
      commit('SET_DELIVERY_TYPE', payload.typeId);
    },
    setDeliveryTime({ commit }, payload) {
      commit('SET_DELIVERY_TIME', payload.timeId);
    },
    async applyCoupon({ commit }, payload) {
      return await axios.get('coupons/' + payload.coupon).then((response) => {
        commit('ADD_COUPON', response.data);
        commit('ADD_COUPON_CODE', payload.coupon);
      });
    },
    setPrice({ commit }, payload) {
      commit('SET_PRICE', payload.price);
    },
    setClientSecret({ commit }, payload) {
      commit('SET_CLIENT_SECRET', payload.clientSecret);
    },
    setOrderId({ commit }, payload) {
      commit('SET_ORDER_ID', payload.orderId);
    },
    async storeOrder(_, payload) {
      return await axios.post('orders', payload.order);
    },
    async updateOrder(_, payload) {
      return await axios.patch(`orders/${payload.orderID}`, payload.order);
    },
    async saveOrderInDraft(_,orderID) {
      return await axios.patch(`orders/${orderID}/set-draft`);
    },
    async acceptQuotationForPostpaidClient(_,orderID) {
      return await axios.patch(`orders/${orderID}/accept-quotation`);
    },
    async createStripePaymentIntent(_, payload) {
      return await axios.post('payment-intents', payload);
    },
    async confirmOrderForTwoCheckout(_, payload) {
      return await axios.post('payments', payload);
    },
    setServiceComponent({ commit }, payload) {
      commit('SET_SERVICE_COMPONENT', payload);
    },
    removeServiceComponent({ commit }, payload) {
      commit('REMOVE_SERVICE_COMPONENT', payload);
    },
    setComplexitykeysinfo({ commit }, payload) {
      commit('SET_COMPLEXITYKEYSINFO', payload);
    },
    setQuotationRequest({ commit }, payload) {
      commit("SET_QUOTATION_REQUEST", payload);
    },
    setDraft({ commit }, payload) {
      commit("SET_DRAFT", payload);
    },
    setIsCreatingOrder({ commit }, payload) {
      commit("SET_IS_CREATING_ORDER", payload);
    },
  }
};
